import {MakeStore, StoreObject} from "../../../stem-core/src/state/Store";
import {field} from "../misc/StoreField";
import {apiClient} from "../../connection/BlinkApiConnection";
import {composePanelOptions} from "../../../blink-sdk/CreatePanelDefaultOptions";
import {MerchantPanelStore} from "./MerchantPanelStore";
import {isPlainObject} from "../../../stem-core/src/base/Utils";
import {loadVersionedObjectFromResponse} from "../misc/StoreUtils";
import {USER_JOURNEY_ACTION_TYPE} from "../../../blink-sdk/Constants.js";
import {asArray} from "../../../blink-sdk/utils/Utils";


export const MerchantUserJourneyType = {
    DEFAULT: "default",
    AB_TEST: "abTest"
};

class MerchantUserJourney extends StoreObject {
    @field("Merchant") merchant;

    @field("MerchantSDKSettings") settingsVersion;
    @field("MerchantUserJourney") versionParent;

    @field(String) name;
    @field options; // JSON
    @field dashboardOptions;

    @field(Date) createdAt;
    @field(Date) lastEditedAt;

    getActions() {
        return asArray(this.options?.action ?? []);
    }

    usesPanel(panel) {
        for (const action of this.getActions()) {
            if (action.panel == panel.id || action.panel == panel.alias) {
                return true;
            }
        }
        return false;
    }

    getCreatePanelAction() {
        return this.getActions().find(action => action.type === USER_JOURNEY_ACTION_TYPE.createPanel);
    }

    getCreatePanelContext() {
        const createPanelAction = this.getCreatePanelAction();
        return composePanelOptions({
                ...(createPanelAction || {}),
                journeyId: this.id,
                journeyAlias: this.alias,
            },
            MerchantPanelStore.filterBy({merchant: this.merchant, settingsVersion: this.settingsVersion}),
        ).context;
    }

    getABTestableContext() {
        let journeyContexts = this.options.context || {};
        journeyContexts = Array.isArray(journeyContexts) ? journeyContexts : [journeyContexts];
        return Object.assign({}, this.getCreatePanelContext(), ...journeyContexts.filter(context => isPlainObject(context)));
    }

    toString() {
        return this.name;
    }

    get type() {
        return this.dashboardOptions.type || MerchantUserJourneyType.DEFAULT;
    }
}

export async function apiCreateMerchantUserJourney(data) {
    const response = await apiClient.post("merchant/create_user_journey/", data);
    return loadVersionedObjectFromResponse(MerchantUserJourneyStore, response, null);
}

export async function apiUpdateMerchantUserJourney(data) {
    const response = await apiClient.post("merchant/update_user_journey/", data);
    return loadVersionedObjectFromResponse(MerchantUserJourneyStore, response, data.merchantUserJourneyId);
}

export async function apiDeleteMerchantUserJourney(merchantUserJourneyId) {
    return apiClient.post("merchant/delete_user_journey/", {merchantUserJourneyId});
}

export const MerchantUserJourneyStore = MakeStore("MerchantUserJourney", MerchantUserJourney, {
    dependencies: ["Merchant", "MerchantSDKSettings", "MerchantPanel"],
});
